import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { browserHistory } from 'react-router';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900 } from 'material-ui/styles/colors';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem'; // eslint-disable-line no-unused-vars
const _ = require('lodash');

const propTypes = {
  dispatch: PropTypes.func,
  salesChannel: PropTypes.any,
  onSave: PropTypes.func,
  catalogs: PropTypes.any,
  settings: PropTypes.any,
  globalSettings: PropTypes.any,
};

class ViewSalesChannel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      settings: {
        clientLogo: '',
        heroImg: {
          desktop: '',
          mobile: '',
        },
        showNavbar: true,
        showHero: true,
        showFooter: true,
        theme: 'default',
        layout: 'default',
        seoName: '',
        seoDescription: '',
        seoTitle: '',
      },
      globalSettings: {
      },
      salesChannel: {
        name: '',
        displayName: '',
        catalogId: 0,
        disabled: false,
        subdomain: '',
        campaignId: '',
        startDate: '',
        endDate: '',
        debugMode: false,
        giftCard: false,
        pickPack: false,
        showPromo: true,
      },
      open: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    const salesChannel = nextProps.salesChannel;
    salesChannel.catalogName = _.result(_.find(this.props.catalogs, { id: this.state.salesChannel.catalogId }), 'name') || '';
    salesChannel.startDate = (salesChannel.startDate !== null) ? salesChannel.startDate.split('T')[0] : '';
    salesChannel.endDate = (salesChannel.startDate !== null) ? salesChannel.startDate.split('T')[0] : '';
    this.setState({
      salesChannel,
      settings: nextProps.settings,
      globalSettings: nextProps.globalSettings,
    });
  }
  navigateToEdit() {
    browserHistory.push(`/saleschannels/${this.props.salesChannel.id}`);
  }
  handleCancel() {
    browserHistory.push('/saleschannels?page=1');
  }
  render() {
    const layoutSettings = (this.state.settings.useGlobalLayout) ? this.state.globalSettings : this.state.settings;
    const seoSettings = (this.state.settings.useGlobalSeo) ? this.state.globalSettings : this.state.settings;
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      datePickerStyle: {
        marginRight: '2%',
        width: '250px',
        float: 'left',
      },
      inline: {
        display: 'flex',
        width: '100%',
      },
      inlineBlock: {
        display: 'inline-block',
        width: '50%',
      },
      passcodeUl: {
        display: 'inline-block',
        width: '33%',
        paddingTop: '30px',
      },
      radioButton: {
        marginBottom: 16,
        float: 'left',
        display: 'inline-block',
      },
    };
    return (
      <div style={{ width: '100%' }}>
        <h2>View Sales Channel</h2>
        <div className="content">
          <div className="float-right">
            <RaisedButton
              style={{ marginRight: '20px' }}
              label="Cancel"
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Edit"
              primary
              onClick={this.navigateToEdit}
            />
          </div>
          <br />
          <TextField
            floatingLabelText="ID"
            floatingLabelStyle={styles.floatingLabelStyle}
            inputStyle={styles.inputStyle}
            value={this.props.salesChannel.id}
          />
          <br />
          <TextField
            floatingLabelText="Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="name"
            style={styles.inputStyle}
            value={this.state.salesChannel.name || ''}
          />
          <TextField
            floatingLabelText="Display Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="displayName"
            style={styles.inputStyle}
            value={this.state.salesChannel.displayName || ''}
          />
          <TextField
            floatingLabelText="Subdomain"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="subdomain"
            style={styles.inputStyle}
            value={this.state.salesChannel.subdomain || ''}
          />
          <br />
          <TextField
            floatingLabelText="Catalog"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="catalogId"
            style={styles.inputStyle}
            value={this.state.salesChannel.catalogName || ''}
          />
          <TextField
            floatingLabelText="Activa Campaign Id"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="campaignId"
            style={styles.inputStyle}
            value={this.state.salesChannel.campaignId || ''}
          />
          <TextField
            floatingLabelText="Start Date"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="startDate"
            style={styles.inputStyle}
            value={this.state.salesChannel.startDate || ''}
          />
          <TextField
            floatingLabelText="End Date"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="endDate"
            style={styles.inputStyle}
            value={this.state.salesChannel.endDate}
          />
          <div className="optionsDiv">
            <ul style={styles.inline}>
              <li>
                <Checkbox
                  label="Disabled"
                  name="salesChannel.disabled"
                  labelStyle={{ marginLeft: '-12px', width: '100px' }}
                  // checked={this.state.salesChannel.disabled}
                />
              </li>
              <li>
                <Checkbox
                  label="Debug Mode"
                  name="salesChannel.debugMode"
                  labelStyle={{ marginLeft: '-12px', width: '130px' }}
                  // checked={this.state.salesChannel.debugMode}
                />
              </li>
            </ul>
            <ul style={styles.inline}>
              <li>
                <Checkbox
                  label="Show Gift Card Product"
                  name="giftCard"
                  labelStyle={{ marginLeft: '-12px', width: '200px' }}
                  // checked={this.state.salesChannel.giftCard}
                />
              </li>
              <li>
                <Checkbox
                  label="Show Pick-Pack Products"
                  name="pickPack"
                  labelStyle={{ marginLeft: '-12px', width: '200px' }}
                  // checked={this.state.salesChannel.pickPack}
                />
              </li>
              <li>
              <Checkbox
                  label="Show Promo Ribbon"
                  name="salesChannel.showPromo"
                  // onCheck={(event) => this.handleChange(event)}
                  labelStyle={{ marginLeft: '-12px', width: '100px' }}
                  defaultChecked={this.state.salesChannel.showPromo}
                />
              </li>
            </ul>
          </div>
          <br />
          <br />
        </div>
        <br />
        <br />
        <br />
        <h2>Layout Options</h2>
        <div className="content">
          <Checkbox
            label="Use Global Layout"
            name="useGlobalLayout"
            labelStyle={{ marginLeft: '-12px', width: '200px' }}
            checked={this.state.settings.useGlobalLayout}
          />
          <br />
          <TextField
            value={layoutSettings.clientLogo || ''}
            floatingLabelText="Client Logo URL"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="clientLogo"
            style={styles.inputStyle}
          />
          <TextField
            value={layoutSettings.heroImg.desktop || ''}
            floatingLabelText="Desktop Hero Image URL"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="settings.heroImg.desktop"
            style={styles.inputStyle}
          />
          <TextField
            value={layoutSettings.heroImg.mobile || ''}
            floatingLabelText="Mobile Hero Image URL"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="settings.heroImg.mobile"
            style={styles.inputStyle}
          />
          <br />
          <br />
          <SelectField
            value={layoutSettings.layout}
            floatingLabelText="Display Template"
            style={{ marginTop: '-25px', float: 'left', verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="layout"
            floatingLabelStyle={styles.floatingLabelStyle}
          >
            <MenuItem value="default" primaryText="Default" />
            <MenuItem value="variation-2" primaryText="Variation-2" />
            <MenuItem value="variation-3" primaryText="Variation-3" />
          </SelectField>
          <SelectField
            value={layoutSettings.theme}
            floatingLabelText="Display Theme"
            style={{ marginTop: '-25px', float: 'left', verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="theme"
            floatingLabelStyle={styles.floatingLabelStyle}
          >
            <MenuItem value="default" primaryText="Default" />
          </SelectField>
          <br />
          <br />
          <br />
          <div style={{ height: '40px', marginTop: '10px' }}>
            <ul style={styles.inline}>
              <li>
                <Checkbox
                  label="Show Navigation Bar"
                  name="showNavbar"
                  labelStyle={{ marginLeft: '-12px', width: '200px' }}
                  checked={layoutSettings.showNavbar}
                />
              </li>
              <li>
                <Checkbox
                  label="Show Hero Image"
                  name="showHero"
                  labelStyle={{ marginLeft: '-12px', width: '200px' }}
                  checked={layoutSettings.showHero}
                />
              </li>
              <li>
                <Checkbox
                  label="Show Footer"
                  name="showFooter"
                  labelStyle={{ marginLeft: '-12px', width: '200px' }}
                  checked={layoutSettings.showFooter}
                />
              </li>
            </ul>
          </div>
        </div>
        <h2>SEO Options</h2>
        <div className="content">
          <Checkbox
            label="Use Global SEO"
            name="useGlobalSeo"
            labelStyle={{ marginLeft: '-12px', width: '200px' }}
            checked={this.state.settings.useGlobalSeo}
          />
          <br />
          <TextField
            floatingLabelText="SEO Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={seoSettings.seoName || ''}
            name="seoName"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="SEO Title"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={seoSettings.seoTitle || ''}
            name="seoTitle"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="SEO Description"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={seoSettings.seoDescription || ''}
            name="seoDescription"
            onChange={this.handleChange}
            style={styles.inputStyle}
            multiLine={true}
          />
        </div>
        <br />
      </div>
    );
  }
}

ViewSalesChannel.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ViewSalesChannel.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    salesChannel: state.salesChannels.salesChannel,
    catalogs: state.catalogs.results,
    settings: state.settings.data,
    globalSettings: state.globalSettings.data,
  };
}

export default connect(mapStateToProps)(ViewSalesChannel);



// WEBPACK FOOTER //
// ./src/components/salesChannels/ViewSalesChannel.js